import { useContext, useLayoutEffect, useState } from 'react'

import { useEvent } from '@js/common/hooks/useEvent'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import { QuizStep } from '@f/applications/QuizApp/partials/types'
import QuestionSlider from '@f/applications/QuizApp/questions/QuestionSlider'

interface Props {
  step: QuizStep
}

export const QuestionFinancialDetails = ({ step }: Props) => {
  const [changesSubmitted, setChangesSubmitted] = useState(false)
  const context = useContext(QuizContext)

  useEvent('NEXT_QUESTION_BUTTON_CLICKED', () => {
    context.actions.updateValues({
      stepID: step.id,
      valuesToSave: step.values.map(value => {
        const sliderConfig = step.sliders?.find(
          ({ name }) => name === value.name
        )
        const minValueSelected = value.value === sliderConfig?.minValue
        return minValueSelected
          ? { name: value.name, value: sliderConfig.defaultValue }
          : value
      })
    })
    setChangesSubmitted(true)
  })

  useLayoutEffect(() => {
    if (changesSubmitted) {
      context.actions.move({ to: 'next' })
    }
  }, [changesSubmitted])

  return <QuestionSlider step={step} />
}
